// @flow

import {useContext} from 'react';
import {LocalesContext} from '../../../../utils/locales';
import React from 'react';
import {BrowserImg, CTA, Line, Title} from './StyledFloatingDesktop';
import {Circle, CloseIcon} from '../../StyledFloatingAddWOT';
import {BROWSER_STORES_LINKS} from '../../../../utils/const';
import {EXTENSION, EXTENSION_CTA_KEY, getStorageKey} from '../../FloatingAddWOT';

type IFloatingDesktopProps = {
    browserName: string,
    pageTrackName: string,
    onClose: (source: string) => void
}

export const FloatingDesktop = ({browserName, pageTrackName, onClose}: IFloatingDesktopProps): any => {
    const {translate} = useContext(LocalesContext);
    const onExtensionClick = () => {
        window.localStorage.setItem(getStorageKey(EXTENSION_CTA_KEY, pageTrackName), 'true');
        onClose(EXTENSION);
    };
    return (
        <React.Fragment>
            <Circle><BrowserImg browserName={browserName} /></Circle>
            <CloseIcon onClick={(): void => onClose(EXTENSION)} />
            <Title>{translate('components.floating.add.wot.ext.title')}</Title>
            <Line>{translate('components.floating.add.wot.ext.line1')}</Line>
            <Line>{translate('components.floating.add.wot.ext.line2')}</Line>
            <Line>{translate('components.floating.add.wot.ext.line3')}</Line>
            <CTA href={BROWSER_STORES_LINKS[browserName]} target="_blank" onClick={onExtensionClick}>{translate('components.floating.add.wot.ext.cta', {browserName})}</CTA>
        </React.Fragment>
    );
};
